import React from "react";
import { Product } from "../../types/product";

interface ProductosListProps {
    products: Product[];
    selectedProduct: Product | null;
    onSelectProduct: (product: Product) => void;
    loading: boolean;
}

const ProductosList: React.FC<ProductosListProps> = ({ products, selectedProduct, onSelectProduct, loading }) => {
    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2 text-muted">Cargando productos...</p>
            </div>);
    }

    if (products.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="bi bi-inbox display-4 text-muted"></i>
                <p className="mt-2 text-muted">No se encontraron productos</p>
            </div>
        );
    }

    return (
        
        <div className="list-group list-group-flush" style={{ maxHeight: '500px', overflowY: 'auto' }}>
            <table className="table table-striped table-hover table-sm table-responsive">
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Medida</th>
                        <th>Marca</th>
                        <th>Precio</th>
                        <th className="text-end">% Imp</th>
                        <th className="text-center">Imagenes ?</th>
                        <th className="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((product, index) => (
                        <tr key={product.productCode} 
                            className={`${selectedProduct?.productCode === product.productCode ? 'border border-primary border-3 table-primary ' : ''}`}
                            style={{cursor: 'pointer'}} 
                            onClick={() => onSelectProduct(product)}>
                            <td>{product.productCode}</td>
                            <td className="text-truncate" style={{maxWidth:"200px"}} title={product.productName}>{product.productName}</td>
                            <td className="text-truncate" style={{maxWidth: "75px"}} title={product.unitOfMeassure}>{product.unitOfMeassure}</td>
                            <td className="text-truncate" >{product.productBrand}</td>
                            <td className="text-center">{product.price.toLocaleString('en-US',{
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</td>
                            <td className="text-center">{product.taxPercentage.toLocaleString('en-US',{ 
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</td>
                            <td className="text-center">{product.hasImages ? 'Si' : 'No'}</td>
                            <td className="text-center">{}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProductosList;